<template>
  <div>
    <template v-if="planList.length==0">
      <div class="no-data">
        <img src="@images/none.png" />
        <div>暂无数据</div>
      </div>
    </template>
    <template v-else>
      <div class="list">
        <div class="item" v-for="item in planList" @click="goDetail(item.taskId)">
          <img :src="item.photo" />
          <div class="pad10">
            <div class="title">{{item.activityName}}</div>
            <div class="num">编号：{{item.number}}</div>
            <div class="flex-sb-c fontcolor-grey">
              <div>活动日期：{{item.startTime}}</div>
              <div>招募人数：{{item.recruitNumber}}人</div>
            </div>
          </div>
          <div class="top-tag">{{name}}</div>
          <div class="top-bottom top-bottom-grey" v-if="item.status==1">已结束</div>
          <div class="top-bottom" v-else>招募中</div>
          <!-- 1报名已满或已过报名时间 2已报名 3未报名 -->

        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    planList: {
      //列表数组
      type: Array,
      required: true,
    },
    name: {
      //策划or其他活动
      type: String,
      required: true,
    },
    total: {
      //总页数
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {},
  watch: {
    planList() {
      // console.log(this.planList)
    }
  },
  methods: {
    goDetail(taskId) {
      let type
      if (this.name == '策划') type = 3
      else if (this.name == '其他活动') type = 4
      this.$router.push({ name: 'serviceDetail', params: { id: taskId, type: type } })
    },
    handleSizeChange(val) {
      this.pageSize = val
      let params = {
        currentPage: 1,
        pageSize: val
      }
      this.$emit("get-list", params)
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val
      let params = {
        currentPage: val,
        pageSize: this.pageSize
      }
      this.$emit("get-list", params)
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.list {
  display: flex;
  justify-content: flex-start;
  margin: 10px 0;
  flex-wrap: wrap;
  .item {
    width: 400px;
    margin: 10px;
    position: relative;
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(224, 229, 237, 1);
    flex: none;
    cursor: pointer;
    .title {
      font-size: 18px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .num {
      margin: 10px 0 30px;
      color: #866e48;
    }
    img {
      width: 100%;
      height: 250px;
    }
    .top-tag {
      position: absolute;
      text-align: center;
      padding: 6px 30px;
      left: 0;
      top: 0;
      background: rgba(0, 94, 110, 0.8);
      color: #fff;
    }
    .top-bottom {
      position: absolute;
      bottom: 56px;
      padding: 6px 10px;
      right: 0;
      background: #ff7800;
      color: #fff;
    }
    .top-bottom-grey {
      background: #c4c4c4;
    }
  }
}
</style>
